/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Unwind position request.
 */
export interface UnwindPositionRequest {
  totalQty: number;
  /**
   * Must be > 0
   */
  steps: number;
  /**
   * Delay between unwind position
   */
  delayBetweenStepsMs: number;
  /**
   * Perpetual leg.
   */
  perpAssetStrategyId: number;
  /**
   * Perpetual leg side. For spot would be used opposite.
   */
  perpTradeSide: UnwindPositionRequest.PerpTradeSideEnum;
  /**
   * Use taker as perpetual leg
   */
  perpTaker: boolean;
  /**
   * Execution order of legs
   */
  executionOrder: UnwindPositionRequest.ExecutionOrderEnum;
  /**
   * Pair IDs for execution. Only LP pairs with same basePairId allowed. Can be null, if its maker spot case.
   */
  spotTakerPairIds?: Array<number>;
  /**
   * Pair IDs for maker execution. Can be null, if its aggressive spot exit case with LPs.
   */
  spotMakerPairId?: number;
  /**
   * Spot flow delta from spread. 0 by default. Formula: \"1 = 0.1BPS = 0.001% = 0.00001\".
   */
  spotSpread?: number;
  /**
   * Spot flow update order frequency. 250 ms by default.
   */
  spotUpdateOrderFrequency?: number;
}
export namespace UnwindPositionRequest {
  export const PerpTradeSideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type PerpTradeSideEnum = (typeof PerpTradeSideEnum)[keyof typeof PerpTradeSideEnum];
  export const ExecutionOrderEnum = {
    PerpLegFirst: 'PERP_LEG_FIRST',
    SpotLegFirst: 'SPOT_LEG_FIRST',
    InParallel: 'IN_PARALLEL',
  } as const;
  export type ExecutionOrderEnum = (typeof ExecutionOrderEnum)[keyof typeof ExecutionOrderEnum];
}
